import { Component } from '@hatiolab/things-scene'

import ControlBase, { DIRECTION, INOUT, NODE, PIPELINE } from './base/control-base'

const IMAGE = new URL('../icons/normalizer.png', import.meta.url).href

const NATURE = {
  mutable: false,
  resizable: false,
  rotatable: false,
  properties: []
}

export default class Normalizer extends ControlBase {
  static IMAGE: HTMLImageElement

  static get nature() {
    return NATURE
  }

  get nodes(): NODE[] {
    return [
      {
        name: 'In',
        description: 'Message inlet',
        inout: INOUT.IN,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.WEST,
        multiplicity: 1
      },
      {
        name: 'Out',
        description: 'Message outlet',
        inout: INOUT.OUT,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.EAST,
        multiplicity: 1
      }
    ]
  }

  getImageElement(): HTMLImageElement {
    if (!Normalizer.IMAGE) {
      Normalizer.IMAGE = new Image()
      Normalizer.IMAGE.src = IMAGE
    }

    return Normalizer.IMAGE
  }
}

Component.register('normalizer', Normalizer)
